import { Box } from '@mui/material';
import { useRef } from 'react';
import ComparePanel from '~/containers/viewer/compare-panel';
import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';
import ContourCompareSection from './ContourCompareSection';
import OperationsPanelHandler from './OperationsPanelHandler';
import OperationsSection from './OperationsSection';
import PostProcessingSection from './PostProcessingSection';
import SliceOperationsSection from './SliceOperationsSection';

export default function OperationsToolbar() {
    const { currentStep } = useWorkflowSteps();
    const toolbarRef = useRef<HTMLElement | null>(null);

    const isContouringStep = currentStep.id === 'contouring';
    const isReviewStep = currentStep.id === 'review';
    if (!isContouringStep && !isReviewStep) {
        return null;
    }

    return (
        <Box
            ref={toolbarRef}
            data-operations-toolbar
            sx={(theme) => ({
                position: 'absolute',
                left: 'calc(100% - 32px)',
                top: '50%',
                transform: 'translate(-100%, -50%)',
                zIndex: 800,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                p: 0.5,
                ...theme.mixins.floatingSurface,
                pointerEvents: 'auto',
            })}
        >
            {isReviewStep && <ContourCompareSection />}
            {isContouringStep && <OperationsSection />}
            <SliceOperationsSection />
            <PostProcessingSection />
            <OperationsPanelHandler toolbarRef={toolbarRef} />
            {/* A body portal beside the toggle that opens it, on either
                surface. */}
            {isReviewStep && <ComparePanel />}
        </Box>
    );
}
